import { useIntl } from "react-intl"

import { Radio, RadioGroup, StaffBodyTextS } from "@doktor-se/bones-ui"
import { AssignedConversation, PaymentRequired } from "@doktor-se/bones-ui/dist/web-shared/types"

import { SearchPageConversation } from "types"

import styles from "./PaymentContent.module.scss"

interface PaymentContentProps {
  conversation: AssignedConversation | SearchPageConversation
  paymentTag?: PaymentRequired
  setPaymentTag: (paymentTag: PaymentRequired) => void
}

const PaymentContent = ({ conversation, paymentTag, setPaymentTag }: PaymentContentProps) => {
  const intl = useIntl()

  const showCardExemptOption = conversation.metadata?.county !== "01" // Stockholm

  return (
    <div className={styles.container}>
      {showCardExemptOption ? (
        <>
          <StaffBodyTextS margin={{ bottom: "var(--size-300)" }}>
            {intl.formatMessage({ id: "control.tag.close" })}
          </StaffBodyTextS>

          <RadioGroup
            label=""
            aria-label="Payment Options"
            value={paymentTag}
            onChange={value => {
              setPaymentTag(value as PaymentRequired)
            }}>
            <Radio value="card_exempt">{intl.formatMessage({ id: "label.yes" })}</Radio>
            <Radio value="payment_accepted">{intl.formatMessage({ id: "label.no" })}</Radio>
            <Radio value="not_relevant">{intl.formatMessage({ id: "label.na" })}</Radio>
          </RadioGroup>
        </>
      ) : (
        <>
          <StaffBodyTextS margin={{ bottom: "var(--size-200)" }}>
            {intl.formatMessage({ id: "control.tag.close.accept.payment" })}
          </StaffBodyTextS>

          <RadioGroup
            label=""
            aria-label="Payment Options"
            value={paymentTag}
            onChange={value => {
              setPaymentTag(value as PaymentRequired)
            }}>
            <Radio value="payment_accepted">{intl.formatMessage({ id: "label.yes" })}</Radio>
            <Radio value="not_relevant">{intl.formatMessage({ id: "label.na" })}</Radio>
          </RadioGroup>
        </>
      )}
    </div>
  )
}

export default PaymentContent
